export type DpFanStagesStateTeams = Record<string, string[]>;
export type DpFanStagesStateSizes = Record<string, string>;
export type DpFanStagesStateSports = string[];
export type DpFanStagesStateBrands = string[];
export type DpFanStagesStateSportGroups = Record<string, string[]>;

export enum DP_FAN_STAGES {
	INITITAL = 'INITITAL',
	SPORTS = 'SPORTS',
	LEAGUES = 'LEAGUES',
	TEAMS = 'TEAMS',
	BRANDS = 'BRANDS',
	SIZES = 'SIZES',
	FINISH = 'FINISH',
}

export type DpFanAnyItem = {
	id: number;
	parentId: number | null;
	name: string;
	hasImage: boolean;
};

export type DpFanSports = DpFanAnyItem[];

export type DpFanTeamData = DpFanAnyItem & { parentName: string };

export type DpFanTeams = Record<string, DpFanTeamData[]>;
